
import PopupPicker from 'vux/src/components/popup-picker/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Popup from 'vux/src/components/popup/index.vue'
import DatetimeView from 'vux/src/components/datetime-view/index.vue'

import DateFormatter from '../../../tools/dateFormatter'
export default{
components: {
PopupPicker,
Popup,
DatetimeView
},
directives: {
TransferDom
},
props: {
defaultPickerTime: ''
},
data() {
return {
show: false,
pickerTime: '',
minDate: '1900-01-01',
maxDate: '2100-12-31'
}
},
methods: {
pickerSureBtnClick() {
if (!this.pickerTime) {
let date = new Date()
this.pickerTime = DateFormatter.dateformate_yyyyMMdd(date)
}
this.$emit('onClickSureBtn', this.pickerTime)
this.show = false
}
},
watch: {
show: function (val, oldVal) {
if (val) {
if (!this.pickerTime || !this.defaultPickerTime) {
let date = new Date()
this.pickerTime = DateFormatter.dateformate_yyyyMMdd(date)
} else {
this.pickerTime = this.defaultPickerTime;
}
if (this.minDate && this.pickerTime < this.minDate) {
this.pickerTime = this.minDate;
}
if (this.maxDate && this.pickerTime > this.maxDate) {
this.pickerTime = this.maxDate;
}
if (this.$refs && this.$refs.datetime) {
this.$refs.datetime.render()
}
}
},
minDate: function (val, oldVal) {
if (!val.length) {
this.minDate = '1900-01-01'
}
},
maxDate: function (val, oldVal) {
if (!val.length) {
this.maxDate = '2100-12-31'
}
}
}
}



// WEBPACK FOOTER //
// ./src/components/views/common/xy-date-picker.vue